<template>
    <div class="messageBox">
        <div class="messageList">
            <el-button class="customize" @click="allRead">全部已读</el-button>
            <div class="message" v-for="(item,index) in news" :key="index">
                <div style="width: 95%">
                    <p>{{item.create_time}}</p>
                    <span @click="viewMessage(item)">{{item.content}}</span>
                </div>
                <div v-if="item.is_read==0" style="width: 5%;text-align: right">未读</div>
                <div v-else="item.is_read==1" style="width: 5%;text-align: right">已读</div>

            </div>
            <el-pagination
                    background
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage"
                    :page-size="pageLimit"
                    layout="prev, pager, next"
                    :total="dataTotalLength">
            </el-pagination>

        </div>
    </div>
</template>

<script>
    import { messageList, readUnread } from '../../api/personal';

    export default {
        inject: ['reload'],
        name: 'message',

        data(){
            return{
                messageStatus:0,
                dataTotalLength:5, //数据总量total
                currentPage:1, //页码
                pageLimit:10, //每页的数据量
                news:{},
            }
        },
        methods:{
            //单个已读
            viewMessage(item){
                if (item.is_read==0) {
                    readUnread(1, item.id).then(res => {
                        console.log(res);
                        if (res.code == 200) {
                            this.reload()
                        }
                    })
                }
            },
            handleCurrentChange(page){
                console.log(page);
                messageList(10,page).then(res=>{
                    console.log(res);
                    this.news=res.data.list
                    this.dataTotalLength=res.data.count
                })
            },
            //全部已读
            allRead(){
                readUnread(0).then(res=>{
                    console.log(res);
                    if (res.code==200){
                        this.reload()
                    }
                })
            }
        },
        created() {
            messageList(10,1).then(res=>{
                console.log(res);
                this.news=res.data.list
                this.dataTotalLength=res.data.count

            })
        }
    };
</script>

<style scoped>
    .messageBox{
        padding: 30px;
        background-color: #fff;
        border-radius: 5px;
    }
    .message{
        padding: 20px 30px;
        border-top: 1px solid #dfdfdf;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .message p{
        margin-bottom: 5px;
    }
    .message span{
        cursor: pointer;
    }
    .message:last-child{
        border-bottom: 1px solid #dfdfdf;

    }
    /deep/.el-pagination{
        text-align: right;
        margin-top: 20px;
    }
    .customize{
        background-color: #3e62f6;
        color: #fff;
        border-radius: 5px;
        margin-bottom: 10px;
    }
</style>
